import { ControlledDateField } from '@act/storybook';
import { DateTime } from 'luxon';
import { Control } from 'react-hook-form';
import type { SurveyFormData } from './types';

export interface DateInputProps {
  control: Control<SurveyFormData>;
  name: string;
  isRequired: boolean;
  minDate?: DateTime<boolean>;
  maxDate?: DateTime<boolean>;
}

const DateInput = ({
  control,
  name,
  isRequired,
  minDate,
  maxDate,
}: DateInputProps) => {
  return (
    <ControlledDateField<SurveyFormData, typeof name>
      control={control}
      name={name}
      label={''}
      inputType={'date'}
      required={isRequired}
      {...(minDate && {
        minDate,
      })}
      {...(maxDate && {
        maxDate,
      })}
    />
  );
};

export default DateInput;
